import { ProductName } from '@hai/ui-react/dist/hook';

export enum PRODUCT {
  X1 = 'X1',
  X4 = 'X4',
  FX = 'FX',
}

export const constant = {
  defaultRefreshInterval: 5000,
  defaultRefreshIntervals: ['00:00:05', '00:00:30', '00:01:00'],
  product: document.body.classList.contains('fx')
    ? PRODUCT.FX
    : document.body.classList.contains('mx1')
    ? PRODUCT.X1
    : PRODUCT.X4,
  productColor: document.body.classList.contains('fx')
    ? '#30cbd1'
    : document.body.classList.contains('mx1')
    ? '#30cbd1'
    : '#9570e3',
  productName: document.body.classList.contains('fx')
    ? ProductName.MAKITO_FX
    : document.body.classList.contains('mx1')
    ? ProductName.MAKITO_X1
    : ProductName.MAKITO_X4_ENCODER,
  isMissionCritical: document.body.classList.contains('fx') || document.body.classList.contains('mx1') ? true : false,
  addMessageEvent: 'add-message',
  clearAllPermanentNotificationEvent: 'clear-all-permanent-notifications',
  clearAllNotificationEvent: 'clear-all-notifications',
  bannerFileTypes: ['.txt'],
  chart: {
    stream: {
      firstFields: ['SendBufs', 'RTT', 'PdDelay'],
      secondFields: ['SendRate', 'ReSnRate', 'AvailBw'],
    },
  },
  defaultCSVFileName: 'CSV-Data',
  obfuscatedPassphrase: '••••••••••' /* utf8 dots */,
  firmware: {
    fileTypes: ['.hai'],
    patternRegex: {
      X1: /makitox1_enc_v\d+.\d+.\d+-\d+.hai/,
      X4: /makitox4_enc_v\d+.\d+.\d+-\d+.hai/,
      FX: /makitofx_enc_v\d+.\d+.\d+-\d+.hai/,
    },
  },
  licenseFileTypes: ['.lic'],
  logoFileTypes: ['.png', '.jpg', '.jpeg', '.bmp', '.gif'],
  lStoragePrefix: 'mx4e:',
  lStorage: {
    brightness: 'mx4e:brightness',
    contrast: 'mx4e:contrast',
    hideAllSlidingPanel: 'mx4e:hideAllSlidingPanel',
    streamPreference: 'mx4e:streamPreference',
    loginRememberMe: 'mx4e:loginRememberMe',
    loginUsername: 'mx4e:loginRememberMe',
    logoView: 'mx4e:logoView',
    presetLoadTable: 'mx4e:presetLoadTable',
    presetTable: 'mx4e:presetTable',
    refreshIntervalStats: 'mx4e:refreshIntervalStats',
    securityTab: 'mx4e:securityTab',
    settingsTab: 'mx4e:settingsTab',
    showUserAnalytics: 'mx4e:showUserAnalytics',
    searchFilter: 'mx4e:searchFilter',
    sidebarCollapsed: 'mx4e:sidebarCollapsed',
    streamingTab: 'mx4e:streamingTab',
    tabAction: 'mx4e:tabAction',
    whatsNewHiddenVersion: 'mx4e:whatsNewHiddenVersion', //Dismiss : don't show until next version
  },
  makitoFXHaivision: 'Haivision Makito FX Encoder',
  makitoX1Haivision: 'Haivision Makito X1 Encoder',
  makitoX4Haivision: 'Haivision Makito X4 Encoder',
  maxNumDecoders: 4, // max amount of decoders, might be lower per license
  maxNumOutput: 4, // amount of SDI outputs
  maxSimultaneousFileUploads: 20,
  momentFormat: {
    api: 'l',
    dateTime: 'l LT',
    presetDateTime: 'lll',
    logo: 'll',
    status: 'l',
    time: 'HH:mm',
    timeWithSeconds: 'HH:mm:ss',
  },
  newModelId: -1,
  onlineCheckURL: 'https://doc.haivision.com',
  presetFileTypes: ['.cfg'],
  pubkeysFileTypes: ['.pub'],
  presetRefreshRateInSeconds: 5,
  bannerMaxFileSize: 1024 * 4,
  stateButtonWaitTime: 500, // default wait time for a state button to show the success/error
  collapseTime: 300,
};

export const SUPPORT_URL =
  'https://support.haivision.com/s/create-case?language=en_US&ec=302&startURL=%2Fs%2Fcreate-case%2F';
export const SUPPORT_PORTAL_URL = 'https://support.haivision.com/s/login/';
//FIXME : Have the actual link to the latest release notes
export const RELEASE_NOTES_URL = 'https://doc.haivision.com/__link_to_latest_release_notes';
